import React from "react";
import "./SecoundImage.css";
import secoundImage from "../../images/secoundImage.png";


const SecoundImage = () => {
  return (
    <div className="container">
     <h1 style={{ textAlign: "center", marginBottom: "20px", position: "relative" }}>
        <span style={{ borderBottom: "5px solid gold", padding: "3px", display: "inline-block" }}>
          Suffah Techno High School E/M
        </span>
      </h1>
      <div className="ab">
        <img src={secoundImage} alt="description" />
      </div>
    </div>
  );
};

export default SecoundImage;
